const menuItemStylesOverrides = {
  root: {
    whiteSpace: "initial"
  }
};
export {
  menuItemStylesOverrides
};
//# sourceMappingURL=styles.es.js.map
